import { useState } from 'react'
import { Tooltip, Image, Space, Tag } from '@arco-design/web-react'
import IconVideo from '@/assets/video-play2x.png'
import Link from 'next/link'
import { VideoModal } from '@/components/VideoModal'
import styles from './index.module.less'
import VideoIcon from '@/assets/video_play.svg'
import useLocale from '@/utils/useLocale'
import EchoNextImage from '@/components/EchoNextImage'
import Copy from '@/components/Copy'

interface Props {
  value: string
  // TODO: 类型定义
  record: any
  canPlay?: boolean
  isGoTiktok?: boolean
}

// 单独抽离第一栏信息展示，将tooltip展示改为受控
const VideoTitleColumn = ({ value, record, canPlay, isGoTiktok }: Props) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const [visible, setVisible] = useState(false)
  const t = useLocale()

  const share_url = record?.share_url

  const borderRadius = '8px'

  const videoUrl = isGoTiktok ? `${record.video_url || ''}` : `/videos/${record.video_id}`

  const isLatest = Number(record.is_latest) === 1

  const playImg = () => {
    if (share_url) {
      setVisible(true)
    } else {
      record?.video_url && window.open(record?.video_url, '_blank')
    }
  }

  if (canPlay && share_url) {
    return (
      <Space>
        <div
          className={styles.imgWrap}
          onClick={() => {
            playImg()
          }}
        >
          <EchoNextImage
            src={record.cover_url}
            alt="video-cover"
            width={88}
            height={88}
            preview={false}
            style={{ borderRadius: borderRadius }}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null // prevents looping
              currentTarget.src = IconVideo?.src
            }}
          />
          <div className={styles['product-video-Montmorillonite']} style={{ borderRadius: borderRadius }}>
            <VideoIcon />
          </div>
        </div>
        <Link href={videoUrl} passHref>
          <a target="_blank">
            <Space direction="vertical">
              {record.highlight ? (
                <Tooltip
                  content={<span dangerouslySetInnerHTML={{ __html: record.highlight }}></span>}
                  popupVisible={showTooltip}
                >
                  <strong
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    onClick={() => {
                      setShowTooltip(false)
                    }}
                    style={{ color: '#403d5a' }}
                    dangerouslySetInnerHTML={{ __html: record.highlight }}
                  ></strong>
                </Tooltip>
              ) : (
                <Tooltip content={record.video_title} popupVisible={showTooltip}>
                  <strong
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    onClick={() => {
                      setShowTooltip(false)
                    }}
                    style={{ color: '#403d5a' }}
                  >
                    {value}
                  </strong>
                </Tooltip>
              )}
              {/* {record.publish_time && <div style={{ color: '#898e99' }}>{record.publish_time}</div>} */}
              <Space align="center">
                {isLatest && (
                  <Tooltip content={t['video.tips.is_new']}>
                    <Tag color="#FFD7DB" defaultChecked style={{ color: '#E70A23' }} size="small">
                      {t['filter.is_new']}
                    </Tag>
                  </Tooltip>
                )}
                {record.is_promote && (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Tooltip content={t['is_promote']}>
                      <Tag color="orangered" size="small">
                        {t['promote']}
                      </Tag>
                    </Tooltip>
                  </div>
                )}
                {record.is_ai_video === 1 && (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Tooltip content={t['is_ai_video']}>
                      <Tag color="blue" size="small">
                        {t['is_ai_video']}
                      </Tag>
                    </Tooltip>
                  </div>
                )}
              </Space>
            </Space>
          </a>
        </Link>
        <Copy text={record.video_title} />
        <VideoModal url={share_url} visible={visible} onCancel={() => setVisible(false)} videoId={record.video_id} />
      </Space>
    )
  }

  return (
    <Link href={`/videos/${record.video_id}`} passHref>
      <a target="_blank">
        <Space>
          <Image
            src={record.cover_url}
            alt="video-cover"
            width={88}
            height={88}
            preview={false}
            style={{ borderRadius: '8px' }}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null // prevents looping
              currentTarget.src = IconVideo?.src
            }}
            onClick={() => {
              setShowTooltip(false)
              window.open(`/videos/${record.video_id}`, '_blank')
            }}
          />
          <Space direction="vertical">
            <Tooltip content={record.video_title} popupVisible={showTooltip}>
              <strong
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                onClick={() => {
                  setShowTooltip(false)
                }}
                style={{ color: '#403d5a' }}
              >
                {value}
              </strong>
            </Tooltip>
            {/* {record.publish_time && <div style={{ color: '#898e99' }}>{record.publish_time}</div>} */}
            <Space align="center">
              {isLatest && (
                <Tooltip content={t['shop.tips.is_new']}>
                  <Tag color="#FFD7DB" defaultChecked style={{ color: '#E70A23' }} size="small">
                    {t['filter.is_new']}
                  </Tag>
                </Tooltip>
              )}
              {record.is_promote && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Tooltip content={t['is_promote']}>
                    <Tag color="orangered" defaultChecked size="small">
                      {t['promote']}
                    </Tag>
                  </Tooltip>
                </div>
              )}
            </Space>
          </Space>
        </Space>
      </a>
    </Link>
  )
}

export default VideoTitleColumn
